import React, { useContext, useEffect, useState } from 'react';

import { Checkbox, FormControlLabel } from '@material-ui/core';
import RadioButtonCheckedRoundedIcon from '@material-ui/icons/RadioButtonCheckedRounded';
import RadioButtonUncheckedRoundedIcon from '@material-ui/icons/RadioButtonUncheckedRounded';

import { GlobalContext } from '../../../../../store';
import { IAdminEvent } from '../../../../../store/admin/events/store';
import { IMetaFormat } from '../../../../../store/admin/roundFormats/store';

import YesNoSwitch from '../../../../../components/YesNoSwitch';
import { useBoolean } from '../../../../common/Hooks/useBoolean.hook';

interface IProps {
  metaFormatToUpdate: IMetaFormat;
  onSaveMetaFormat: (format: IMetaFormat) => void;
}

export const SameFormatForAllRounds = (props: IProps) => {
  const { metaFormatToUpdate, onSaveMetaFormat } = props;

  const [formatForAllRounds, setFormatForAllRounds, toggleFormatForAllRounds] = useBoolean();

  const { adminEvents } = useContext(GlobalContext);

  const onSelectRound = (selectEventValue: any) => {
    const selectedRoundId = Number(selectEventValue.target.value);

    const metaFormatRounds = metaFormatToUpdate.rounds;

    const rounds = metaFormatRounds.includes(selectedRoundId)
      ? metaFormatRounds.filter(roundId => roundId !== selectedRoundId)
      : [...metaFormatRounds, selectedRoundId];

    const { metadata } = metaFormatToUpdate;

    if (metadata) {
      delete metadata[selectedRoundId];
    }

    onSaveMetaFormat({ ...metaFormatToUpdate, rounds });
  };

  const [event, setEvent] = useState<IAdminEvent | undefined>(undefined);

  useEffect(() => {
    const adminEvent = adminEvents[metaFormatToUpdate.event];

    if (adminEvent) {
      setEvent(adminEvent);
    }
  }, [adminEvents, metaFormatToUpdate]);

  useEffect(() => {
    if (event) {
      const eventRounds = event.rounds.map(round => round.id);

      setFormatForAllRounds(eventRounds.length === metaFormatToUpdate.rounds.length);
    }
  }, [event, metaFormatToUpdate]);

  useEffect(() => {
    if (event) {
      const eventRounds = event.rounds.map(round => round.id);

      if (formatForAllRounds && metaFormatToUpdate.rounds.length !== eventRounds.length) {
        onSaveMetaFormat({ ...metaFormatToUpdate, rounds: eventRounds });
      }
    }
  }, [formatForAllRounds]);

  return (
    <>
      <span className="format-label">DOES THIS EVENT HAVE THE SAME FORMAT FOR ALL ROUNDS?</span>

      <YesNoSwitch onChange={toggleFormatForAllRounds} checked={formatForAllRounds} />

      {!formatForAllRounds && (
        <div>
          <span className="format-label players-per-team">SELECT THE ROUNDS</span>

          {event ? (
            event.rounds.map((round, index) => (
              <FormControlLabel
                key={`round-subformat-checkbox-${round.id}`}
                className="round-subformat-checkbox override"
                classes={{ label: 'label' }}
                control={
                  <Checkbox
                    className="check-considered-flight"
                    id={`check-selected-round-${round.id}`}
                    checked={metaFormatToUpdate.rounds.includes(round.id)}
                    onChange={onSelectRound}
                    icon={<RadioButtonUncheckedRoundedIcon fontSize="large" />}
                    checkedIcon={<RadioButtonCheckedRoundedIcon fontSize="large" />}
                    value={String(round.id)}
                    color="primary"
                  />
                }
                label={`${index + 1}`}
              />
            ))
          ) : (
            <></>
          )}
        </div>
      )}
    </>
  );
};
